// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lb-layout {
  display: grid;
  grid-template-columns: 216px 1fr;
  /* La fila debe llenar el viewport como mínimo y crecer con el contenido. Con
     una sola fila \`auto\` y sólo \`min-height\`, el contenido más corto que el
     viewport dejaba un hueco abajo (la fila no se estiraba), y ni el sidebar
     oscuro ni el body cubrían ese espacio. minmax(100vh, auto) lo evita. */
  grid-template-rows: minmax(100vh, auto);
  min-height: 100vh;
  background: var(--paper);
  color: var(--ink);
  font-size: var(--fs-ui);
  font-family: var(--font-sans);
}

/* Collapsed sidebar → narrow icon rail; content reclaims the freed width. */
.lb-layout--collapsed {
  grid-template-columns: 52px 1fr;
}

/* Sticky sidebar — pin the column to the viewport so the nav stays visible
   while the content area scrolls. The grid track is still 240px wide; only
   the sidebar's positioning changes. */
.lb-layout > :first-child {
  position: sticky;
  top: 0;
  /* Sticky makes the rail a stacking context, so the account menu's own
     z-index only ranks it inside the rail. Without a layer for the rail
     itself, main's positioned content (the Inicio tiles) comes later in the
     DOM and paints over the open menu. */
  z-index: var(--z-sticky);
  align-self: start;
  /* Sidebar.css sets min-height:100% on .sidebar-b, which in a grid context
     stretches it to the row track (= page height). That makes the element
     as tall as the document, so sticky has no room to pin. Cap it. */
  height: 100vh;
  max-height: 100vh;
  min-height: 0;
  overflow-y: auto;
}

.lb-layout__main {
  display: flex;
  flex-direction: column;
  /* Was overflow:hidden, which forced the inner content to manage its own
     scroll — that's why the sticky-on-the-page approach didn't work for the
     sidebar before. Let the page-level scroll handle long lists. */
  min-height: 100vh;
  /* Grid-blowout guard: a \`1fr\` track is really \`minmax(auto, 1fr)\`, so its
     \`auto\` minimum lets wide content (the Ledger table) grow the column past
     the viewport, spilling the page horizontally. Pinning the grid item's
     min-width to 0 lets it shrink to its track; the table (width:100%) then
     fits and wraps inside it instead of overflowing. */
  min-width: 0;
}

.lb-layout__disabled {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 48px 24px;
  text-align: center;
}

.lb-layout__disabled-title {
  margin: 0;
  font-size: var(--fs-h3);
  font-weight: 600;
}

.lb-layout__disabled-subtitle {
  margin: 0;
  color: var(--ink-3);
}
`, "",{"version":3,"sources":["webpack://./src/app/MainLayout.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC;;;2EAGyE;EACzE,uCAAuC;EACvC,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA,4EAA4E;AAC5E;EACE,+BAA+B;AACjC;;AAEA;;uCAEuC;AACvC;EACE,gBAAgB;EAChB,MAAM;EACN;;;yCAGuC;EACvC,wBAAwB;EACxB,iBAAiB;EACjB;;qEAEmE;EACnE,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;;mEAEiE;EACjE,iBAAiB;EACjB;;;;uDAIqD;EACrD,YAAY;AACd;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB","sourcesContent":[".lb-layout {\n  display: grid;\n  grid-template-columns: 216px 1fr;\n  /* La fila debe llenar el viewport como mínimo y crecer con el contenido. Con\n     una sola fila `auto` y sólo `min-height`, el contenido más corto que el\n     viewport dejaba un hueco abajo (la fila no se estiraba), y ni el sidebar\n     oscuro ni el body cubrían ese espacio. minmax(100vh, auto) lo evita. */\n  grid-template-rows: minmax(100vh, auto);\n  min-height: 100vh;\n  background: var(--paper);\n  color: var(--ink);\n  font-size: var(--fs-ui);\n  font-family: var(--font-sans);\n}\n\n/* Collapsed sidebar → narrow icon rail; content reclaims the freed width. */\n.lb-layout--collapsed {\n  grid-template-columns: 52px 1fr;\n}\n\n/* Sticky sidebar — pin the column to the viewport so the nav stays visible\n   while the content area scrolls. The grid track is still 240px wide; only\n   the sidebar's positioning changes. */\n.lb-layout > :first-child {\n  position: sticky;\n  top: 0;\n  /* Sticky makes the rail a stacking context, so the account menu's own\n     z-index only ranks it inside the rail. Without a layer for the rail\n     itself, main's positioned content (the Inicio tiles) comes later in the\n     DOM and paints over the open menu. */\n  z-index: var(--z-sticky);\n  align-self: start;\n  /* Sidebar.css sets min-height:100% on .sidebar-b, which in a grid context\n     stretches it to the row track (= page height). That makes the element\n     as tall as the document, so sticky has no room to pin. Cap it. */\n  height: 100vh;\n  max-height: 100vh;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.lb-layout__main {\n  display: flex;\n  flex-direction: column;\n  /* Was overflow:hidden, which forced the inner content to manage its own\n     scroll — that's why the sticky-on-the-page approach didn't work for the\n     sidebar before. Let the page-level scroll handle long lists. */\n  min-height: 100vh;\n  /* Grid-blowout guard: a `1fr` track is really `minmax(auto, 1fr)`, so its\n     `auto` minimum lets wide content (the Ledger table) grow the column past\n     the viewport, spilling the page horizontally. Pinning the grid item's\n     min-width to 0 lets it shrink to its track; the table (width:100%) then\n     fits and wraps inside it instead of overflowing. */\n  min-width: 0;\n}\n\n.lb-layout__disabled {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 48px 24px;\n  text-align: center;\n}\n\n.lb-layout__disabled-title {\n  margin: 0;\n  font-size: var(--fs-h3);\n  font-weight: 600;\n}\n\n.lb-layout__disabled-subtitle {\n  margin: 0;\n  color: var(--ink-3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
